import React from "react";
import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import { useDeploymentLineLegalPublisher } from "@Front/Services/DeploymentLineLegalPublisher/DeploymentLineLegalPublisherContext";
import LinkInline from "../../elements/LinkInline";
import { Routes, buildRoute } from "@Front/Config/Routes";
import { ELegalOptions } from "@Front/Components/LayoutTemplates/DefaultLegalDashboard";

export function CGUSection6(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				6. Liens hypertextes
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				{pub.publisherLegalName} se réserve la possibilité de mettre en place des hyperliens sur son Site, donnant accès à des pages web autres
				que celles de son Site sur lesquels {pub.publisherLegalName} n&apos;exerce aucun contrôle.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				{pub.publisherLegalName} décline toute responsabilité quant aux conditions d&apos;accès à ces pages web, à leur fonctionnement, à leur
				utilisation des données à caractère personnel des Internautes et quant au contenu des informations fournies sur ces pages
				web au titre de l&apos;activation des hyperliens.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute qui dispose d&apos;un site internet à titre personnel et désire placer, à des fins personnelles, sur son site un
				lien simple renvoyant directement sur la page d&apos;accueil du Site {pub.cguSiteHomeDeepLinkFrenchTail}, doit obtenir l&apos;autorisation expresse de
				{pub.publisherLegalName} pour établir ce lien.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				En aucun cas, cette autorisation ne pourra être qualifiée de convention implicite d&apos;affiliation.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				En toute hypothèse, les liens hypertextes renvoyant au Site sans l&apos;autorisation de {pub.publisherLegalName} devront être retirés à
				première demande de {pub.publisherLegalName}.
			</Typography>
		</section>
	);
}

function CGUSection7ParagraphsA(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				{pub.publisherLegalName} fait ses meilleurs efforts, conformément aux règles de l&apos;art, pour sécuriser le Site au regard du risque encouru
				et de la nature des données traitées. Toutefois, {pub.publisherLegalName} ne saurait être responsable, s&apos;agissant de ce point, qu&apos;en cas
				de faute prouvée imputable à cette dernière. Il ne saurait assurer une sécurité absolue.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Il est interdit à l&apos;Internaute d&apos;accéder ou de se maintenir, frauduleusement, dans tout ou partie du Site. Il s&apos;interdit
				d&apos;utiliser une méthode d&apos;accès autre que l&apos;interface mise à disposition par {pub.publisherLegalName}. En cas de découverte d&apos;une telle
				méthode ou si l&apos;Internaute entre dans un espace réservé, sans droit, par inadvertance, celui-ci s&apos;engage à en informer sans
				délai {pub.publisherLegalName} par courrier électronique à l&apos;adresse ({pub.contactEmail}) afin qu&apos;il puisse prendre les mesures
				nécessaires.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Il est interdit à l&apos;Internaute de supprimer ou modifier des données contenues sur le Site qui n&apos;auraient pas été publiées
				par lui-même, ou d&apos;y introduire frauduleusement des données ou même d&apos;opérer une altération du fonctionnement du Site. Il
				veille notamment à ne pas introduire de virus, code malveillant ou toute autre technologie nuisible au Site
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				Tout accès à un espace interdit sera considéré comme un accès frauduleux au sens des dispositions du Code pénal.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute s&apos;engage à considérer que toutes les données dont il aura eu connaissance à l&apos;occasion d&apos;un tel accès à un
				espace non autorisé sont des données confidentielles et s&apos;engage, en conséquence, à ne pas les divulguer.
			</Typography>
		</>
	);
}

function CGUSection7ParagraphsB(): React.JSX.Element {
	return (
		<>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute s&apos;interdit notamment de réaliser toute opération visant à saturer une page, les opérations de rebond ou toute
				opération ayant pour conséquence d&apos;entraver ou de fausser le fonctionnement du Site
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute s&apos;engage à ne pas utiliser de dispositifs ou de logiciels de toutes sortes qui auraient pour conséquence de
				perturber le bon fonctionnement du Site.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute s&apos;engage à ne pas engager d&apos;action qui imposerait une charge disproportionnée sur les infrastructures du Site.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute accepte les caractéristiques et limites de l&apos;internet. Il a conscience que les données circulant sur l&apos;internet
				ne sont pas nécessairement protégées, notamment contre les détournements éventuels.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute prend les mesures appropriées pour assurer la sécurité de ses propres données et / ou logiciels de la
				contamination par des éventuels virus sur le réseau internet.
			</Typography>
		</>
	);
}

export function CGUSection7(): React.JSX.Element {
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				7. Sécurité
			</Typography>
			<CGUSection7ParagraphsA />
			<CGUSection7ParagraphsB />
		</section>
	);
}

export function CGUSection8(): React.JSX.Element {
	const pub = useDeploymentLineLegalPublisher();
	return (
		<section>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
				8. Données à caractère personnel
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				{pub.publisherLegalName} déclare qu&apos;il traite les données à caractère personnel conformément aux dispositions de la loi n°78-17 du 6
				janvier 1978 modifiée et du Règlement (UE) 2016/679 du 27 avril 2016 (RGPD).
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute est invité à se référer aux
				<LinkInline
					text="Politique de confidentialité"
					href={buildRoute(Routes.pages.Legal.LegalInformations, { legalUid: ELegalOptions.POLITIQUE_DE_CONFIDENTIALITE })}
				/>
				concernant l&apos;utilisation par {pub.publisherLegalName} des données à caractère personnel.
			</Typography>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
				L&apos;Internaute est invité à se référer aux
				<LinkInline
					text=" Politiques de Cookies"
					href={buildRoute(Routes.pages.Legal.LegalInformations, { legalUid: ELegalOptions.POLITIQUE_DE_GESTION_DES_COOKIES })}
				/>
				concernant l&apos;utilisation par {pub.publisherLegalName} des cookies.
			</Typography>
		</section>
	);
}
